<template>
  <div class="fixed top-4 right-4 z-50 space-y-2">
    <TransitionGroup name="notification" tag="div">
      <div
        v-for="notification in notifications"
        :key="notification.id"
        class="max-w-sm bg-white rounded-lg shadow-lg border-l-4 p-4"
        :class="getNotificationClass(notification.type)"
      >
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <Icon
              :name="getNotificationIcon(notification.type)"
              class="w-5 h-5"
              :class="getIconClass(notification.type)"
            />
          </div>
          <div class="ml-3 flex-1">
            <p class="text-sm font-medium text-gray-900">
              {{ notification.title }}
            </p>
            <p v-if="notification.message" class="mt-1 text-sm text-gray-500">
              {{ notification.message }}
            </p>
          </div>
          <div class="ml-4 flex-shrink-0">
            <button
              @click="removeNotification(notification.id)"
              class="inline-flex text-gray-400 hover:text-gray-600 focus:outline-none"
            >
              <Icon name="uil:times" class="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
const { notifications, removeNotification } = useNotification()

const getNotificationClass = (type: string) => {
  switch (type) {
    case 'success':
      return 'border-green-400'
    case 'error':
      return 'border-red-400'
    case 'warning':
      return 'border-yellow-400'
    case 'info':
      return 'border-blue-400'
    default:
      return 'border-gray-400'
  }
}

const getNotificationIcon = (type: string) => {
  switch (type) {
    case 'success':
      return 'uil:check-circle'
    case 'error':
      return 'uil:times-circle'
    case 'warning':
      return 'uil:exclamation-triangle'
    case 'info':
      return 'uil:info-circle'
    default:
      return 'uil:bell'
  }
}

const getIconClass = (type: string) => {
  switch (type) {
    case 'success':
      return 'text-green-400'
    case 'error':
      return 'text-red-400'
    case 'warning':
      return 'text-yellow-400'
    case 'info':
      return 'text-blue-400'
    default:
      return 'text-gray-400'
  }
}
</script>

<style scoped>
.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.notification-move {
  transition: transform 0.3s ease;
}
</style>